<mat-toolbar class="mat-elevation-z8">
  {{ isEditMode ? ('PARKING_EDIT.TITLE_EDIT' | transloco) : ('PARKING_EDIT.TITLE_ADD' | transloco) }}
</mat-toolbar>

<mat-dialog-content>
  <form [formGroup]="parkingForm" (ngSubmit)="onSubmit()">
    <div class="form-group">
      <mat-form-field appearance="outline" class="w-100">
        <mat-label>{{ 'PARKING_EDIT.PARKING_NAME' | transloco }}</mat-label>
        <input matInput formControlName="parkingName" required>
        @if (parkingForm.get('parkingName')?.hasError('required')) {
          <mat-error>
            {{ 'PARKING_EDIT.PARKING_NAME_REQUIRED' | transloco }}
          </mat-error>
        }
      </mat-form-field>
    </div>

    <div class="feature-item mb-3" formGroupName="parkingDescription">
      <h4 class="mb-3">{{ 'PARKING_EDIT.DESCRIPTION' | transloco }}</h4>
      <div class="d-flex gap-2">
        <mat-form-field appearance="outline" class="flex-grow-1">
          <mat-label>{{ 'PARKING_EDIT.ENGLISH' | transloco }}</mat-label>
          <input matInput formControlName="en" [placeholder]="'PARKING_EDIT.ENGLISH_TEXT' | transloco">
        </mat-form-field>
        <mat-form-field appearance="outline" class="flex-grow-1">
          <mat-label>{{ 'PARKING_EDIT.SWEDISH' | transloco }}</mat-label>
          <input matInput formControlName="sv" [placeholder]="'PARKING_EDIT.SWEDISH_TEXT' | transloco">
        </mat-form-field>
      </div>
    </div>

    <div class="form-group">
      <mat-form-field appearance="outline" class="w-100">
        <mat-label>{{ 'PARKING_EDIT.PARKING_MARGIN_HOURS' | transloco }}</mat-label>
        <input matInput type="number" formControlName="parkingMarginHours">
      </mat-form-field>
    </div>

    <div class="form-group">
      <mat-form-field appearance="outline" class="w-100">
        <mat-label>{{ 'PARKING_EDIT.COMMUNICATION_PARKING_SPOT_LEVEL' | transloco }}</mat-label>
        <input matInput type="number" formControlName="communicationParkingSpotLevel">
      </mat-form-field>
    </div>

    <div class="form-group">
      <mat-form-field appearance="outline" class="w-100">
        <mat-label>{{ 'PARKING_EDIT.FREE_PARKING_SITE_GAP_HOURS' | transloco }}</mat-label>
        <input matInput type="number" formControlName="freeParkingSiteGapHours">
      </mat-form-field>
    </div>

    <div class="form-group">
      <mat-form-field appearance="outline" class="w-100">
        <mat-label>{{ 'PARKING_EDIT.CHECKIN_BEFORE_PARKING_START' | transloco }}</mat-label>
        <input matInput type="number" formControlName="checkinBeforeParkingStart" min="0" max="12" step="1">
      </mat-form-field>
    </div>

    <div class="form-group">
      <mat-form-field appearance="outline" class="w-100">
        <mat-label>{{ 'PARKING_EDIT.CHECKIN_AFTER_PARKING_START' | transloco }}</mat-label>
        <input matInput type="number" formControlName="checkinAfterParkingStart" min="-10" max="-1" step="1">
      </mat-form-field>
    </div>

    <div class="form-group">
      <mat-form-field appearance="outline" class="w-100">
        <mat-label>{{ 'PARKING_EDIT.CHECKOUT_BEFORE_PARKING_END' | transloco }}</mat-label>
        <input matInput type="number" formControlName="checkOutBeforeParkingEnd" min="-8760" max="-1" step="1">
      </mat-form-field>
    </div>

    <div class="form-group">
      <mat-form-field appearance="outline" class="w-100">
        <mat-label>{{ 'PARKING_EDIT.CHECKOUT_AFTER_PARKING_END' | transloco }}</mat-label>
        <input matInput type="number" formControlName="checkOutAfterParkingEnd" min="0" max="24" step="1">
      </mat-form-field>
    </div>

    <div class="feature-item mb-3">
      <h4 class="mb-3">{{ 'PARKING_EDIT.WORKING_PERIOD' | transloco }}</h4>
      <div class="d-flex gap-2 align-items-start">
        <mat-form-field appearance="outline" class="flex-grow-1">
          <mat-label>{{ 'PARKING_EDIT.WORKING_PERIOD_FROM' | transloco }}</mat-label>
          <input matInput [matDatepicker]="workFromPicker" formControlName="workFrom">
          <mat-datepicker-toggle matSuffix [for]="workFromPicker"></mat-datepicker-toggle>
          <mat-datepicker #workFromPicker></mat-datepicker>
        </mat-form-field>
        <mat-form-field appearance="outline" class="flex-grow-1">
          <mat-label>{{ 'PARKING_EDIT.WORKING_PERIOD_TO' | transloco }}</mat-label>
          <input matInput [matDatepicker]="workToPicker" formControlName="workTo">
          <mat-datepicker-toggle matSuffix [for]="workToPicker"></mat-datepicker-toggle>
          <mat-datepicker #workToPicker></mat-datepicker>
        </mat-form-field>
        <button mat-icon-button type="button" [disabled]="!parkingForm.value.workFrom && !parkingForm.value.workTo"
          (click)="clearWorkPeriod()" [attr.aria-label]="'PARKING_EDIT.WORKING_PERIOD_CLEAR' | transloco"
          [matTooltip]="'PARKING_EDIT.WORKING_PERIOD_CLEAR' | transloco">
          <mat-icon>close</mat-icon>
        </button>
      </div>
    </div>

    <div class="form-group">
      <mat-form-field appearance="outline" class="w-100">
        <mat-label>{{ 'PARKING_EDIT.EMAIL' | transloco }}</mat-label>
        <input matInput type="email" formControlName="email">
      </mat-form-field>
    </div>

    <div class="form-group">
      <mat-form-field appearance="outline" class="w-100">
        <mat-label>{{ 'PARKING_EDIT.EMAIL_NAME' | transloco }}</mat-label>
        <input matInput type="text" formControlName="emailName" />
      </mat-form-field>
    </div>

    <div class="form-group">
      <mat-form-field appearance="outline" class="w-100">
        <mat-label>{{ 'PARKING_EDIT.CONFIRMATION_TEMPLATE' | transloco }}</mat-label>
        <input matInput type="text" formControlName="confirmationTemplate" />
      </mat-form-field>
    </div>

    <div class="form-group">
      <mat-form-field appearance="outline" class="w-100">
        <mat-label>{{ 'PARKING_EDIT.ADDITIONAL_PAYMENT_TEMPLATE' | transloco }}</mat-label>
        <input matInput type="text" formControlName="additionalPaymentTemplate" />
      </mat-form-field>
    </div>

    <div class="form-group">
      <mat-form-field appearance="outline" class="w-100">
        <mat-label>{{ 'PARKING_EDIT.CHECKIN_TEMPLATE' | transloco }}</mat-label>
        <input matInput type="text" formControlName="checkinTemplate" />
      </mat-form-field>
    </div>

    <div class="form-group">
      <mat-form-field appearance="outline" class="w-100">
        <mat-label>{{ 'PARKING_EDIT.WELCOME_HOME_TEMPLATE' | transloco }}</mat-label>
        <input matInput type="text" formControlName="welcomeHomeTemplate" />
      </mat-form-field>
    </div>

    <div class="form-group">
      <mat-form-field appearance="outline" class="w-100">
        <mat-label>{{ 'PARKING_EDIT.ADDITIONAL_SERVICE_OFFER_TEMPLATE' | transloco }}</mat-label>
        <input matInput type="text" formControlName="additionalServiceOfferTemplate" />
      </mat-form-field>
    </div>

    <div class="form-group">
      <mat-form-field appearance="outline" class="w-100">
        <mat-label>{{ 'PARKING_EDIT.CANCEL_TEMPLATE' | transloco }}</mat-label>
        <input matInput type="text" formControlName="cancelTemplate" />
      </mat-form-field>
    </div>

    <div class="form-group">
      <mat-form-field appearance="outline" class="w-100">
        <mat-label>{{ 'PARKING_EDIT.NO_SHOW_STATUS_AFTER_HOURS' | transloco }}</mat-label>
        <input matInput type="number" formControlName="noShowStatusAfterHours"
          [placeholder]="'PARKING_EDIT.NO_SHOW_STATUS_AFTER_HOURS_PLACEHOLDER' | transloco">
      </mat-form-field>
    </div>

    <div class="form-group">
      <mat-checkbox formControlName="active">{{ 'PARKING_EDIT.ACTIVE' | transloco }}</mat-checkbox>
    </div>

    <div class="form-group">
      <mat-checkbox formControlName="additionalServices">{{ 'PARKING_EDIT.ADDITIONAL_SERVICES' | transloco
      }}</mat-checkbox>
    </div>

    <div class="form-group">
      <mat-checkbox formControlName="disabledParkingSpace">{{ 'PARKING_EDIT.DISABLED_PARKING_SPACE' | transloco
      }}</mat-checkbox>
    </div>

    <div class="form-group">
      <mat-checkbox formControlName="indoors">{{ 'PARKING_EDIT.INDOORS' | transloco }}</mat-checkbox>
    </div>

    <div class="form-group">
      <mat-checkbox formControlName="largeCars">{{ 'PARKING_EDIT.LARGE_CARS' | transloco }}</mat-checkbox>
    </div>

    <div class="form-group">
      <mat-checkbox formControlName="electricalCharging">
        {{ 'PARKING_EDIT.ELECTRICAL_CHARGING' | transloco}}
      </mat-checkbox>
    </div>

    <div class="form-group">
      <mat-checkbox formControlName="subscriptionParking">
        {{ 'PARKING_EDIT.SUBSCRIPTION_PARKING' | transloco}}
      </mat-checkbox>
    </div>

    <div class="form-group">
      <mat-checkbox formControlName="overbooking">
        {{ 'PARKING_EDIT.OVERBOOKING' | transloco}}
      </mat-checkbox>
    </div>

    <div class="form-group">
      <mat-checkbox formControlName="allowMultipleEntries">
        {{ 'PARKING_EDIT.ALLOW_MULTIPLE_ENTRIES' | transloco}}
      </mat-checkbox>
    </div>

    <div class="form-group">
      <mat-checkbox formControlName="allowDriveUp">
        {{ 'PARKING_EDIT.ALLOW_DRIVE_UP' | transloco}}
      </mat-checkbox>
    </div>

    <div class="form-group">
      <mat-checkbox formControlName="hideOnCustomerPortal">
        {{ 'PARKING_EDIT.HIDE_ON_CUSTOMER_PORTAL' | transloco}}
      </mat-checkbox>
    </div>

    <div class="form-group">
      <mat-checkbox formControlName="allowDynamicPricing">
        {{ 'PARKING_EDIT.ALLOW_DYNAMIC_PRICING' | transloco}}
      </mat-checkbox>
    </div>

    @if (parkingForm.value.allowDynamicPricing) {
      <div class="feature-item mb-3" formArrayName="dynamicPricingRules">
        <h4 class="mb-2">{{ 'PARKING_EDIT.DYNAMIC_PRICING_RULES' | transloco }}</h4>
        <p class="dynamic-pricing-hint">{{ 'PARKING_EDIT.DYNAMIC_PRICING_RULES_HINT' | transloco }}</p>

        @if (dynamicPricingRules.length) {
          <div class="dynamic-pricing-grid">
            <div class="dynamic-pricing-header">{{ 'PARKING_EDIT.RULE_TYPE' | transloco }}</div>
            <div class="dynamic-pricing-header">{{ 'PARKING_EDIT.VALUE' | transloco }}</div>
            <div class="dynamic-pricing-header">{{ 'PARKING_EDIT.MULTIPLIER' | transloco }}</div>
            <div></div>

            @for (rule of dynamicPricingRules.controls; track rule; let i = $index) {
              <ng-container [formGroupName]="i">
                <mat-form-field appearance="outline" subscriptSizing="dynamic">
                  <mat-select formControlName="type">
                    @for (type of dynamicPricingRuleTypes; track type) {
                      <mat-option [value]="type">{{ 'PARKING_EDIT.RULE_TYPE_' + type | transloco }}</mat-option>
                    }
                  </mat-select>
                </mat-form-field>
                <mat-form-field appearance="outline" subscriptSizing="dynamic">
                  <input matInput type="number" min="0" formControlName="value" required>
                  @if (isPercentRule(rule.value.type)) {
                    <span matTextSuffix>%</span>
                  }
                </mat-form-field>
                <mat-form-field appearance="outline" subscriptSizing="dynamic">
                  <span matTextPrefix>×&nbsp;</span>
                  <input matInput type="number" min="0.01" step="0.1" formControlName="multiplier" required>
                </mat-form-field>
                <button mat-icon-button type="button" (click)="removeDynamicPricingRule(i)"
                  [attr.aria-label]="'PARKING_EDIT.REMOVE_RULE' | transloco"
                  [matTooltip]="'PARKING_EDIT.REMOVE_RULE' | transloco">
                  <mat-icon>delete</mat-icon>
                </button>

                @if (rule.hasError('percentOutOfRange')) {
                  <mat-error class="span-all">{{ 'PARKING_EDIT.RULE_PERCENT_OUT_OF_RANGE' | transloco }}</mat-error>
                }
                @if (rule.hasError('notWholeNumber')) {
                  <mat-error class="span-all">{{ 'PARKING_EDIT.RULE_NOT_WHOLE_NUMBER' | transloco }}</mat-error>
                }
              </ng-container>
            }
          </div>
        } @else {
          <p class="dynamic-pricing-hint">{{ 'PARKING_EDIT.NO_RULES' | transloco }}</p>
        }

        <button mat-stroked-button type="button" class="mt-2" (click)="addDynamicPricingRule()">
          <mat-icon>add</mat-icon>
          {{ 'PARKING_EDIT.ADD_RULE' | transloco }}
        </button>
      </div>

      <div class="feature-item mb-3" formArrayName="specialPricingPeriods">
        <h4 class="mb-2">{{ 'PARKING_EDIT.SPECIAL_PRICING_PERIODS' | transloco }}</h4>
        <p class="dynamic-pricing-hint">{{ 'PARKING_EDIT.SPECIAL_PRICING_PERIODS_HINT' | transloco }}</p>

        @if (specialPricingPeriods.length) {
          <div class="special-periods-grid">
            <div class="dynamic-pricing-header">{{ 'PARKING_EDIT.PERIOD_NAME' | transloco }}</div>
            <div class="dynamic-pricing-header">{{ 'PARKING_EDIT.PERIOD_FROM' | transloco }}</div>
            <div class="dynamic-pricing-header">{{ 'PARKING_EDIT.PERIOD_TO' | transloco }}</div>
            <div class="dynamic-pricing-header">{{ 'PARKING_EDIT.PERIOD_RECURRING' | transloco }}</div>
            <div class="dynamic-pricing-header">{{ 'PARKING_EDIT.MULTIPLIER' | transloco }}</div>
            <div></div>

            @for (period of specialPricingPeriods.controls; track period; let i = $index) {
              <ng-container [formGroupName]="i">
                <mat-form-field appearance="outline" subscriptSizing="dynamic">
                  <input matInput formControlName="name" required>
                </mat-form-field>
                <mat-form-field appearance="outline" subscriptSizing="dynamic">
                  <input matInput [matDatepicker]="periodFromPicker" formControlName="from" required>
                  <mat-datepicker-toggle matSuffix [for]="periodFromPicker"></mat-datepicker-toggle>
                  <mat-datepicker #periodFromPicker></mat-datepicker>
                </mat-form-field>
                <mat-form-field appearance="outline" subscriptSizing="dynamic">
                  <input matInput [matDatepicker]="periodToPicker" formControlName="to" required>
                  <mat-datepicker-toggle matSuffix [for]="periodToPicker"></mat-datepicker-toggle>
                  <mat-datepicker #periodToPicker></mat-datepicker>
                </mat-form-field>
                <mat-checkbox class="text-center" formControlName="recurring"></mat-checkbox>
                <mat-form-field appearance="outline" subscriptSizing="dynamic">
                  <span matTextPrefix>×&nbsp;</span>
                  <input matInput type="number" min="0.01" step="0.1" formControlName="multiplier" required>
                </mat-form-field>
                <button mat-icon-button type="button" (click)="removeSpecialPricingPeriod(i)"
                  [attr.aria-label]="'PARKING_EDIT.REMOVE_PERIOD' | transloco"
                  [matTooltip]="'PARKING_EDIT.REMOVE_PERIOD' | transloco">
                  <mat-icon>delete</mat-icon>
                </button>

                @if (period.hasError('endsBeforeStart')) {
                  <mat-error class="span-all">{{ 'PARKING_EDIT.PERIOD_ENDS_BEFORE_START' | transloco }}</mat-error>
                }
              </ng-container>
            }
          </div>
          @if (specialPricingPeriods.errors?.['overlap']; as overlap) {
            <mat-error class="mt-1">{{ 'PARKING_EDIT.PERIODS_OVERLAP' | transloco: overlap }}</mat-error>
          }
        } @else {
          <p class="dynamic-pricing-hint">{{ 'PARKING_EDIT.NO_PERIODS' | transloco }}</p>
        }

        <button mat-stroked-button type="button" class="mt-2" (click)="addSpecialPricingPeriod()">
          <mat-icon>add</mat-icon>
          {{ 'PARKING_EDIT.ADD_PERIOD' | transloco }}
        </button>
      </div>
    }

    @if (isEditMode) {
      <div class="feature-item mb-3" formArrayName="discountQuotas">
        <h4 class="mb-2">{{ 'PARKING_EDIT.DISCOUNT_QUOTA' | transloco }}</h4>
        <p class="dynamic-pricing-hint">{{ 'PARKING_EDIT.DISCOUNT_QUOTA_HINT' | transloco }}</p>

        @if (discountQuotas.length) {
          <div class="discount-quotas-grid">
            <div class="dynamic-pricing-header">{{ 'PARKING_EDIT.DISCOUNT_QUOTA_CODE' | transloco }}</div>
            <div class="dynamic-pricing-header">{{ 'PARKING_EDIT.DISCOUNT_QUOTA_MIN' | transloco }}</div>
            <div class="dynamic-pricing-header">{{ 'PARKING_EDIT.DISCOUNT_QUOTA_MAX' | transloco }}</div>
            <div class="dynamic-pricing-header">{{ 'PARKING_EDIT.PERIOD_FROM' | transloco }}</div>
            <div class="dynamic-pricing-header">{{ 'PARKING_EDIT.PERIOD_TO' | transloco }}</div>
            <div></div>

            @for (quota of discountQuotas.controls; track quota; let i = $index) {
              <ng-container [formGroupName]="i">
                <mat-form-field appearance="outline" subscriptSizing="dynamic">
                  <mat-select formControlName="discountCheckId" required>
                    @for (discountCheck of discountChecks; track discountCheck.id) {
                      <mat-option [value]="discountCheck.id">{{ discountCheck.discountCode }}</mat-option>
                    }
                  </mat-select>
                </mat-form-field>
                <mat-form-field appearance="outline" subscriptSizing="dynamic">
                  <input matInput type="number" min="0" max="100" formControlName="minPercent">
                  <span matTextSuffix>%</span>
                </mat-form-field>
                <mat-form-field appearance="outline" subscriptSizing="dynamic">
                  <input matInput type="number" min="0" max="100" formControlName="maxPercent">
                  <span matTextSuffix>%</span>
                </mat-form-field>
                <mat-form-field appearance="outline" subscriptSizing="dynamic">
                  <input matInput [matDatepicker]="quotaFromPicker" formControlName="from">
                  <mat-datepicker-toggle matSuffix [for]="quotaFromPicker"></mat-datepicker-toggle>
                  <mat-datepicker #quotaFromPicker></mat-datepicker>
                </mat-form-field>
                <mat-form-field appearance="outline" subscriptSizing="dynamic">
                  <input matInput [matDatepicker]="quotaToPicker" formControlName="to">
                  <mat-datepicker-toggle matSuffix [for]="quotaToPicker"></mat-datepicker-toggle>
                  <mat-datepicker #quotaToPicker></mat-datepicker>
                </mat-form-field>
                <button mat-icon-button type="button" (click)="removeDiscountQuota(i)"
                  [attr.aria-label]="'PARKING_EDIT.REMOVE_DISCOUNT_QUOTA' | transloco"
                  [matTooltip]="'PARKING_EDIT.REMOVE_DISCOUNT_QUOTA' | transloco">
                  <mat-icon>delete</mat-icon>
                </button>

                @if (quota.get('minPercent')?.invalid || quota.get('maxPercent')?.invalid) {
                  <mat-error class="span-all">{{ 'PARKING_EDIT.DISCOUNT_QUOTA_PERCENT_OUT_OF_RANGE' | transloco }}</mat-error>
                }
                @if (quota.hasError('noLimits')) {
                  <mat-error class="span-all">{{ 'PARKING_EDIT.DISCOUNT_QUOTA_NO_LIMITS' | transloco }}</mat-error>
                }
                @if (quota.hasError('minAboveMax')) {
                  <mat-error class="span-all">{{ 'PARKING_EDIT.DISCOUNT_QUOTA_MIN_ABOVE_MAX' | transloco }}</mat-error>
                }
                @if (quota.hasError('endsBeforeStart')) {
                  <mat-error class="span-all">{{ 'PARKING_EDIT.PERIOD_ENDS_BEFORE_START' | transloco }}</mat-error>
                }
                @if (quota.hasError('startsBeforeDiscount')) {
                  <mat-error class="span-all">{{ 'PARKING_EDIT.DISCOUNT_QUOTA_STARTS_BEFORE_DISCOUNT' | transloco }}</mat-error>
                }
                @if (quota.hasError('endsAfterDiscount')) {
                  <mat-error class="span-all">{{ 'PARKING_EDIT.DISCOUNT_QUOTA_ENDS_AFTER_DISCOUNT' | transloco }}</mat-error>
                }
              </ng-container>
            }
          </div>
          @if (discountQuotas.errors?.['overlap']; as overlap) {
            <mat-error class="mt-1">{{ 'PARKING_EDIT.DISCOUNT_QUOTAS_OVERLAP' | transloco: overlap }}</mat-error>
          }
        } @else {
          <p class="dynamic-pricing-hint">{{ 'PARKING_EDIT.NO_DISCOUNT_QUOTAS' | transloco }}</p>
        }

        @if (quotaLoadError !== null) {
          <mat-error class="mt-1">{{ 'PARKING_EDIT.DISCOUNT_QUOTA_LOAD_ERROR' | transloco }}{{ quotaLoadError ? ': ' + quotaLoadError : '' }}</mat-error>
        }
        @if (quotaSaveError !== null) {
          <mat-error class="mt-1">{{ 'PARKING_EDIT.DISCOUNT_QUOTA_SAVE_ERROR' | transloco }}{{ quotaSaveError ? ': ' + quotaSaveError : '' }}</mat-error>
        }

        <button mat-stroked-button type="button" class="mt-2" (click)="addDiscountQuota()">
          <mat-icon>add</mat-icon>
          {{ 'PARKING_EDIT.ADD_DISCOUNT_QUOTA' | transloco }}
        </button>
      </div>
    }

    <div class="features-section mt-4">
      <h3 class="mb-3">{{ 'PARKING_EDIT.FEATURES' | transloco }}</h3>

      <div class="feature-item mb-3" formGroupName="feature1">
        <h4 class="mb-3">{{ 'PARKING_EDIT.FEATURE' | transloco: { number: 1 } }}</h4>
        <div class="d-flex gap-2">
          <mat-form-field appearance="outline" class="flex-grow-1">
            <mat-label>{{ 'PARKING_EDIT.ENGLISH' | transloco }}</mat-label>
            <input matInput formControlName="en" [placeholder]="'PARKING_EDIT.ENGLISH_TEXT' | transloco">
          </mat-form-field>
          <mat-form-field appearance="outline" class="flex-grow-1">
            <mat-label>{{ 'PARKING_EDIT.SWEDISH' | transloco }}</mat-label>
            <input matInput formControlName="sv" [placeholder]="'PARKING_EDIT.SWEDISH_TEXT' | transloco">
          </mat-form-field>
        </div>
      </div>

      <div class="feature-item mb-3" formGroupName="feature2">
        <h4 class="mb-3">{{ 'PARKING_EDIT.FEATURE' | transloco: { number: 2 } }}</h4>
        <div class="d-flex gap-2">
          <mat-form-field appearance="outline" class="flex-grow-1">
            <mat-label>{{ 'PARKING_EDIT.ENGLISH' | transloco }}</mat-label>
            <input matInput formControlName="en" [placeholder]="'PARKING_EDIT.ENGLISH_TEXT' | transloco">
          </mat-form-field>
          <mat-form-field appearance="outline" class="flex-grow-1">
            <mat-label>{{ 'PARKING_EDIT.SWEDISH' | transloco }}</mat-label>
            <input matInput formControlName="sv" [placeholder]="'PARKING_EDIT.SWEDISH_TEXT' | transloco">
          </mat-form-field>
        </div>
      </div>

      <div class="feature-item mb-3" formGroupName="feature3">
        <h4 class="mb-3">{{ 'PARKING_EDIT.FEATURE' | transloco: { number: 3 } }}</h4>
        <div class="d-flex gap-2">
          <mat-form-field appearance="outline" class="flex-grow-1">
            <mat-label>{{ 'PARKING_EDIT.ENGLISH' | transloco }}</mat-label>
            <input matInput formControlName="en" [placeholder]="'PARKING_EDIT.ENGLISH_TEXT' | transloco">
          </mat-form-field>
          <mat-form-field appearance="outline" class="flex-grow-1">
            <mat-label>{{ 'PARKING_EDIT.SWEDISH' | transloco }}</mat-label>
            <input matInput formControlName="sv" [placeholder]="'PARKING_EDIT.SWEDISH_TEXT' | transloco">
          </mat-form-field>
        </div>
      </div>

      <div class="feature-item mb-3" formGroupName="feature4">
        <h4 class="mb-3">{{ 'PARKING_EDIT.FEATURE' | transloco: { number: 4 } }}</h4>
        <div class="d-flex gap-2">
          <mat-form-field appearance="outline" class="flex-grow-1">
            <mat-label>{{ 'PARKING_EDIT.ENGLISH' | transloco }}</mat-label>
            <input matInput formControlName="en" [placeholder]="'PARKING_EDIT.ENGLISH_TEXT' | transloco">
          </mat-form-field>
          <mat-form-field appearance="outline" class="flex-grow-1">
            <mat-label>{{ 'PARKING_EDIT.SWEDISH' | transloco }}</mat-label>
            <input matInput formControlName="sv" [placeholder]="'PARKING_EDIT.SWEDISH_TEXT' | transloco">
          </mat-form-field>
        </div>
      </div>

      <div class="feature-item mb-3" formGroupName="feature5">
        <h4 class="mb-3">{{ 'PARKING_EDIT.FEATURE' | transloco: { number: 5 } }}</h4>
        <div class="d-flex gap-2">
          <mat-form-field appearance="outline" class="flex-grow-1">
            <mat-label>{{ 'PARKING_EDIT.ENGLISH' | transloco }}</mat-label>
            <input matInput formControlName="en" [placeholder]="'PARKING_EDIT.ENGLISH_TEXT' | transloco">
          </mat-form-field>
          <mat-form-field appearance="outline" class="flex-grow-1">
            <mat-label>{{ 'PARKING_EDIT.SWEDISH' | transloco }}</mat-label>
            <input matInput formControlName="sv" [placeholder]="'PARKING_EDIT.SWEDISH_TEXT' | transloco">
          </mat-form-field>
        </div>
      </div>

      <div class="feature-item mb-3" formGroupName="feature6">
        <h4 class="mb-3">{{ 'PARKING_EDIT.FEATURE' | transloco: { number: 6 } }}</h4>
        <div class="d-flex gap-2">
          <mat-form-field appearance="outline" class="flex-grow-1">
            <mat-label>{{ 'PARKING_EDIT.ENGLISH' | transloco }}</mat-label>
            <input matInput formControlName="en" [placeholder]="'PARKING_EDIT.ENGLISH_TEXT' | transloco">
          </mat-form-field>
          <mat-form-field appearance="outline" class="flex-grow-1">
            <mat-label>{{ 'PARKING_EDIT.SWEDISH' | transloco }}</mat-label>
            <input matInput formControlName="sv" [placeholder]="'PARKING_EDIT.SWEDISH_TEXT' | transloco">
          </mat-form-field>
        </div>
      </div>
    </div>
  </form>
</mat-dialog-content>

<mat-dialog-actions align="end">
  <button mat-button (click)="onCancel()" [disabled]="isLoading">{{ 'PARKING_EDIT.CANCEL' | transloco }}</button>
  <button mat-raised-button color="primary" (click)="onSubmit()" [disabled]="!parkingForm.valid || isLoading">
    {{ isEditMode ? ('PARKING_EDIT.SAVE' | transloco) : ('PARKING_EDIT.SAVE' | transloco) }}
  </button>
</mat-dialog-actions>
